import {Injectable} from '@angular/core';
import {saveAs} from 'file-saver';
import {Datacenter} from '../model/datacenter';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {tap} from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class FileDownloaderService {
  constructor(private http: HttpClient) {
  }

  downloadCsv(mapId: string, mapName:string) {
    return this.http.get(`${environment.apiDatacentersUrl}/page/${mapId}/csv?loading=true`, {responseType: 'text'}).pipe(
      tap(res => {
        const blob = new Blob([res], { type: 'text/csv;charset=utf-8;' });
        const filename = this.generateFileName(mapName);
        saveAs(blob, filename);
      })
    ).subscribe();
  }

  private formatDatacenterAsCsvRow(datacenter: Datacenter): string {
    const fields = [
      datacenter.country,
      datacenter.market,
      datacenter.mapId,
      datacenter.provider,
      datacenter.area,
      datacenter.building,
      datacenter.mwLive,
      datacenter.mwUC,
      datacenter.mwPlanned,
      datacenter.mwTotal,
      datacenter.dataHallLive,
      datacenter.dataHallUC,
      datacenter.dataHallPlanned,
      datacenter.dataHallTotal,
      datacenter.buildingAreaLive,
      datacenter.buildingAreaUC,
      datacenter.buildingAreaPlanned,
      datacenter.buildingAreaTotal,
      datacenter.address,
      datacenter.firstYearOp,
      datacenter.lat,
      datacenter.lon,
      (datacenter.buildingTenant || []).join('|'),
      datacenter.campus,
      datacenter.sellableITLoad,
      datacenter.availabilityZoneId,
      (datacenter.productType || []).join('|'),
      (datacenter.siteType || []).join('|'),
      (datacenter.dataSource || []).join('|'),
      datacenter.weightedAverageLeaseTermYears,
      datacenter.parcelSizeAcres
    ].map((field) => this.escapeField(field));
    return fields.join(',');
  }

  private escapeField(field) {
    let toConvert = '';
    if (field != null && field != undefined) {
      toConvert = field.toString();
      if (toConvert.indexOf(',') != -1) {
        toConvert = '"' + toConvert.replaceAll('"', '') + '"';
      }
    }
    return toConvert;
  }

  private generateFileName(baseName: string, extension = 'csv'): string {
    const date = new Date();
    const dateString = `${date.getDate().toString().padStart(2, '0')}${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, '0')}${date.getFullYear()}`;
    return `${baseName}-${dateString}.${extension}`;
  }
}
